import { module } from 'modujs';
import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText.js";
export default class extends module {
    constructor(m) {
        super(m);

        // Binding
        this.onFontsLoadedBind = this.onFontsLoaded.bind(this);

        //config
        this.delay = this.getData('delay') || 0;
        this.type = this.getData('type') || 'words';
        this.stagger = this.getData('stagger') || 0.1;

        gsap.registerPlugin(SplitText);
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        gsap.config({
            nullTargetWarn: false
        });

        this.bindEvents();

        this.el.style.visibility = 'hidden';

        if (window.isFontsLoaded) {
            this.onFontsLoaded();
        }
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        window.addEventListener("fontsLoaded", this.onFontsLoadedBind);
    }

    unbindEvents() {
        window.removeEventListener("fontsLoaded", this.onFontsLoadedBind);
    }

    ////////////////////
    // Methods
    ////////////////////

    onFontsLoaded() {
        setTimeout(() => {
            this.splitText = new SplitText(this.el, { type: this.type });
            this.splitText = new SplitText(this.el, { type: this.type });

            requestAnimationFrame(() => {
                this.$words = this.el.querySelectorAll('div > *');

                gsap.set(this.$words, {
                    y: '177%'
                });

                this.el.style.visibility = 'visible';
            });
        }, 10);
    }

    animate(event) {
        setTimeout(() => {
            if (event.obj.el != this.el) {
                return;
            }

            gsap.to(this.$words, {
                duration: 1,
                y: 0,
                force3D: true,
                opacity: 1,
                delay: this.delay,
                ease: "power4.out",
                stagger: this.stagger
            });
        }, 20);
    }

    destroy() {
        super.destroy();
        this.unbindEvents();
    }
}
